export const appendToFormData = (formData: FormData, key: string, value: any) => {
  if (value !== undefined && value !== null) {
    formData.append(key, value)
  }

  return formData
}
